export const avatarString = (s) => {
    if (!s || !s.length) {
        return "";
    }
    //let words = s.split(/\s/);
    s = s.match(/[A-Z]/g).join("");
    return s;
};
